<template>
  <!-- <v-dialog
    v-model="dialog"
    scrollable
    persistent
    :overlay="false"
    max-width="350"
    transition="dialog-transition"
  > -->
  <!-- <template v-slot:activator="{ on }">
      <v-btn text v-on="on"> Exchange </v-btn>
    </template> -->
  <v-card>
    <v-toolbar :class="colorChange">
      <v-toolbar-title>{{ Exchange.sellOrBuy }} - Exchange</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        :color="Exchange.sellOrBuy === 'Buy' ? 'black' : 'white'"
        @click="close"
        icon
      >
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-form ref="ExchangeForme" v-model="valid">
        <v-row dense class="justify-center">
          <v-col cols="12" md="6" lg="6" xl="6">
            <v-radio-group
              readonly
              :rules="[v => !!v || 'Exchang Type is required']"
              v-model="Exchange.sellOrBuy"
              :column="false"
            >
              <v-radio class="mr-5" label="Sell" value="Sell"></v-radio>
              <v-radio label="Buy" value="Buy"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="8">
            <v-select
              v-model.trim="Exchange.sellorBuyType"
              :items="GetCashTypes"
              :rules="[v => !!v || 'Cash Type is required']"
              label="Cash Type"
              required
            ></v-select>
          </v-col>
          <!-- currency Amount and its formating Number -->
          <v-col cols="8">
            <v-text-field
              v-model.number.trim="Exchange.sellorBuyAmount"
              :rules="[v => !!v || 'Amount is required']"
              name="ExchangeAmount"
              label="Amount"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p
              v-if="Exchange.sellorBuyAmount"
              class="font-weight-black text-center black--text"
            >
              {{ Exchange.sellorBuyType | MoneySigns }}
              {{ Exchange.sellorBuyAmount.toLocaleString() }}
            </p>
          </v-col>
          <!-- currency Rate and its Calculation Number -->
          <v-col cols="8">
            <v-select
              v-model.trim="ExchangType"
              :items="
                Exchange.sellorBuyType == UsersToken.CashBase
                  ? CurrencyTyps
                  : GetCashTypes
              "
              :rules="[v => !!v || 'Exchange Type is required']"
              :disabled="ExchangType == UsersToken.CashBase ? true : false"
              label="Exchange Type"
              required
            ></v-select>
          </v-col>
          <v-col cols="8">
            <v-text-field
              v-model.number.trim="Exchange.Rate"
              :rules="[v => !!v || 'Rate is required']"
              name="ExchangeAmountRate"
              label="Ratet"
              type="number"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <p
              class="font-weight-black text-center black--text"
              v-if="localCurrence && localCurrence > 0"
            >
              <!-- {{ localCurrence.toLocaleString() }} -->
              {{ (Math.round(localCurrence * 100) / 100).toLocaleString() }}
              {{ ExchangType | MoneySigns }}
            </p>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn block :loading="clicked" :color="colorChange" @click="OnExchange"
        >{{ Exchange.sellOrBuy }} - Money</v-btn
      >
    </v-card-actions>
    <p class="text-center mb-3 red--text d-block">{{ ErrorMsg }}</p>
  </v-card>
  <!-- </v-dialog> -->
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: { showBalance: { type: Function } },
  data() {
    return {
      //   sellOrBuy: "",
      dialog: false,
      valid: true,
      ErrorMsg: "",
      clicked: false,
      ExchangType: "",
      Exchange: {
        sellorBuyAmount: "",
        Rate: "",
        sellorBuyType: "",
        sellOrBuy: "",
        Amount: "",
      },
    };
  },
  computed: {
    ...mapGetters(["GetCashTypes", "UsersToken"]),
    CurrencyTyps() {
      if (this.GetCashTypes.length > 0)
        return this.GetCashTypes.filter(value => {
          return value.value != this.UsersToken.CashBase;
        });
      else return [];
    },
    watchSellOrBuyType() {
      return this.Exchange.sellorBuyType;
    },
    colorChange() {
      if (this.Exchange.sellOrBuy === "Sell") return "green white--text";
      else if (this.Exchange.sellOrBuy == "Buy") return "yellow black--text";
      else return "black white--text";
    },
    localCurrence() {
      if (
        this.Exchange.Rate &&
        this.Exchange.sellorBuyAmount &&
        !isNaN(this.Exchange.Rate) &&
        !isNaN(this.Exchange.sellorBuyAmount)
      )
        if (this.Exchange.sellorBuyType == this.UsersToken.CashBase)
          return (
            Number(this.Exchange.sellorBuyAmount) / Number(this.Exchange.Rate)
          );
        else return this.Exchange.Rate * this.Exchange.sellorBuyAmount;
      else return 0;
    },
  },
  watch: {
    watchSellOrBuyType(v) {
      if (v == this.UsersToken.CashBase) {
        this.Exchange.sellOrBuy = "Sell";
        this.ExchangType = "USD";
      } else {
        this.Exchange.sellOrBuy = "Buy";
        this.ExchangType = this.UsersToken.CashBase;
      }
    },
    localCurrence(val) {
      this.Exchange.Amount = Math.round(val * 100) / 100;
    },
    // Etype(val) {
    //   // console.log(val);
    //   if (!val) this.$refs.ExchangeForme.reset();
    //   else this.Exchange.sellOrBuy = val;
    // }
  },
  methods: {
    close() {
      this.dialog = false;
      this.$refs.ExchangeForme.reset();
    },
    OnExchange() {
      this.ErrorMsg = "";
      if (this.$refs.ExchangeForme.validate()) {
        this.clicked = true;
        this.Exchange.date = this.Current().date;
        this.Exchange.time = this.Current().time;
        this.Exchange.homeType = this.UsersToken.CashBase;
        let data = { ...this.Exchange };
        if (this.Exchange.sellOrBuy == "Sell") {
          data.Amount = this.Exchange.sellorBuyAmount;
          data.sellorBuyAmount = this.Exchange.Amount;
          data.sellorBuyType = this.ExchangType;
        }
        this.$store
          .dispatch("INSERT_ONLY", {
            url: `/exchange/${this.Exchange.sellOrBuy}`,
            data,
          })
          .then(() => {
            this.clicked = false;
            this.showBalance("Main Cash");
            this.$refs.ExchangeForme.reset();
            // console.log(result);
          })
          .catch(error => {
            this.clicked = false;
            if (error.response.status === 400)
              this.ErrorMsg = error.response.data;
          });
      }
    },
  },
  mounted() {
    // this.Exchange.sellOrBuy = this.Etype;
  },
};
</script>
